<template>
  <div>
    <div v-if="brand">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <h3>
            {{ brand.brand }}
          </h3>
        </div>
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Brand Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="brand.brand"
                      @input="updateBrand($event, 'brand')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Aff Program</td>
                  <td>
                    <e-txt
                    type="select"
                      :text="brand.affiliateProgram ? brand.affiliateProgram.name : ''"
                      :options="affCompanies"
                      @input="updateBrand($event, 'affiliateProgram')"
                      select-value="id"
                      select-label="name"
                      close-on-save="true"
                      :selected-value="brand.affiliateProgram ? brand.affiliateProgram.name : ''"
                      :locked="!user.admin"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>License</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="brand.license"
                      @input="updateBrand($event, 'license')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Products</td>
                  <td>
                    <e-txt
                      type="select"
                      @input="updateBrand($event, 'products')"
                      close-on-save="true"></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="brand.status"
                      :options="statuses"
                      @input="updateBrand($event, 'status')"
                      select-value="id"
                      select-label="label"
                      close-on-save="true"
                      :selected-value="brand.status"
                      :locked="!user.admin"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Notes</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="brand.note"
                      @input="updateBrand($event, 'note')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { BRAND_SET } from '../../../../store/mutation-types'

export default {
  data () {
    return {
      statuses: [
        {label: 'Active', id: 'active'},
        {label: 'Not active', id: 'not-active'},
        {label: 'Blacklisted', id: 'blacklisted'}
      ],
      affCompanies: []
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand',
      user: 'getUser'
    })
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    document.title = 'Brand :: PBN360 by Aphex Media'
    this.getAffCompany()
  },
  methods: {
    async updateBrand (val, prop) {
      try {
        let data = {}
        data[prop] = val
        let resp = await axios.patch(`/advertisers/brands/${this.brand.id}`, data)
        this.$toastr.success(`${prop} updated successfully`, 'Good')
        this.$store.commit(BRAND_SET, resp.data)
      } catch (error) {
        this.$toastr.error(error, 'Unable to update')
      }
    },
    async getAffCompany () {
      try {
        let resp = await axios.get('/advertisers/affiliate-companies')
        this.affCompanies = resp.data
      } catch (e) {
        console.error(e, 'Error fetching Affiliate Companies')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand/Header.vue